/**
 * In order to get the key configs from the Chimera console add the key name with the default
 * value here in this config. If will fetch the configuration based of the rule set configured
 * in the chimera dashboard for the keys mentioned here below.
 */

const defaultChimeraConfig = {
	QMC_REPORT_ENABLED: false,
	PAYLINK_ENABLED: false,
	OFFLINE_PAYLINK_AMOUNT_LIMIT: 25000,
	NOTIFICATIONS_ENABLED: false,
	ONLINE_PAYLINK_FILTERS_ENABLED: false,
	ONLINE_PAYLINK_ACTIVATION_DISABLED: false,
	OMX_TRANSACTIONS_API_ENABLED: false,
	ONLINE_PAYLINKS_HIDE: false,
	ONLINE_MERCHANT_CALLBACK_ENABLED: false,
	ONLINE_TRANSACTION_LIST_V2_ENABLED: false,
	MIRA_SCAN_ENABLED: false,
	SHOW_SETTLEMENT_CHATBOT: false,
	ONLINE_MX_VIA_MIGS_ENABLED: false,
	MERCHANT_ANNOUNCEMENT_WIDGET: null,
	NCMC_MERCHANT: false,
	TRANSACTION_DETAILS_CHARGES: [],
	NOTIFICATION_WIDGET: {},
	SR_DASHBOARD_ENABLED: false,
	VENDOR_ONBOARDING: false,
	OM_TEST_MODE_ENABLED: false,
};

export default defaultChimeraConfig;
